import actions from './actions';
import mutations from './mutations';

export const makeInitialState = () => ({
  data: [],
  status: 'Unfetched',
  errMessage: null,
});

const getters = {
  getIssuesPayload(state, gtters, rootState, rootGetters) {
    return {
      projectId: rootGetters['projects/projectId'],
      recordingId: rootGetters['recordings/currentId'],
    };
  },
};

export default {
  namespaced: true,
  state: makeInitialState(),
  actions,
  mutations,
  getters,
  hagridResources: {
    getIssues: 'getIssuesPayload',
  },
  hagridOn: {
    logout: 'clear',
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/issues/index.js